import React from 'react';

// material-ui
import { IconButton, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import MainCard from './MainCard';
import { makeStyles } from 'tss-react/mui';

// ==============================|| CUSTOM MAIN CARD ||============================== //

const ContentCard = React.forwardRef(
    (
        { title, link, subTitle, icon, children, onClick },
        ref
    ) => {
        const { classes } = useStyles();

        // If link exists, wrap the entire card with Link
        const Wrapper = link ? Link : 'div';

        return (
            <Wrapper to={link} onClick={onClick}
                className={classes.linkWrapper} style={{ textDecoration: 'none' }}
            >
                <div className={classes.contentcard}>
                    <div className={classes.sideBorder}></div>
                    <MainCard>
                        <Typography color="primary" variant="h3" style={{ fontWeight: 'bold' }}>
                            {title}
                        </Typography>
                        {icon && (
                            <IconButton
                                sx={{
                                    background: (theme) => theme.palette.gradiant.main,
                                    color: 'white',
                                    float: 'right'
                                }}
                            >
                                {icon}
                            </IconButton>
                        )}
                        <Typography variant="h4" color="text.primary" style={{ marginTop: '20px' }}>
                            {subTitle}
                        </Typography>
                        {children}
                    </MainCard>
                </div>
            </Wrapper>
        );
    }
);

const useStyles = makeStyles({ name: 'ContentCard' })((theme) => ({
    contentcard: {
        minHeight: '110px',
        cursor: 'pointer' // Ensures the card looks clickable
    },
    sideBorder: {
        width: '3px',
        backgroundColor: theme.palette.success.main,
        position: 'absolute',
        minHeight: '139px',
        borderRadius: '20px'
    },
    linkWrapper: {
        display: 'block'
    }
}));

export default ContentCard;
